import { render } from "./box_gutarget.vue?vue&type=template&id=3f38cc20"
import script from "./box_gutarget.vue?vue&type=script&setup=true&lang=js"
export * from "./box_gutarget.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/box_gutarget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f38cc20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f38cc20', __exports__)) {
    console.log('reload')
    api.reload('3f38cc20', __exports__)
  }
  
  module.hot.accept("./box_gutarget.vue?vue&type=template&id=3f38cc20", () => {
    console.log('re-render')
    api.rerender('3f38cc20', render)
  })

}


export default __exports__